// hooks/useFormViewerWizard/repatchStep1.ts — Samakan order sesi dgn keranjang terbaru.
//
// KENAPA: kalau user mengubah varian/jumlah di step 1, dulu order sesi TIDAK dipakai
// lagi (sig beda) -> insert order baru -> dedup membatalkan order lama = 2 baris
// (1 Pending + 1 Canceled). Sekarang order draft yang sama DI-PATCH (produk/varian/
// harga/jumlah) + ongkir di-reset (kurir dipilih ulang di step 2).
import { buildOrderPayload } from '../useFormViewer/submitPayload';
import { patchWizardOrder, patchWizardStep1Identity } from './patchWizardOrder';
import { buildStep1Sig } from './step1Sig';

export async function repatchWizardStep1(args: {
    hook: any; form: any; orderId: string; minMid: number;
}): Promise<void> {
    const { hook, form, orderId } = args;
    if (!orderId) throw new Error('Order sesi tidak ada');
    const built = await buildOrderPayload({
        form, customerData: hook.customerData, addressData: hook.addressData,
        selectedOptions: hook.selectedOptions, selectedShippingKey: hook.selectedShippingKey,
        selectedPaymentKey: undefined, selectedDuitkuMethod: null,
        selectedEverproRate: null, selectedBiteshipRate: null,
        currentCombination: hook.currentCombination, linkedProductName: hook.linkedProductName || '',
        quantity: hook.quantity, shippingCost: 0, codFee: 0, orderId, uniqueCode: 1,
        isCODVal: false, isSimpleEmbed: false, herbalClaimMode: undefined,
        discountAmount: hook.discountAmount || 0, voucherCode: hook.couponApplied?.code || '',
        sourceFormOverride: 'wizard_step1',
        bumpProductIds: hook.selectedBumpIds || [],
        bumpSum: hook.bumpSum || 0,
    });
    const p = built.pOrder;
    await patchWizardOrder(orderId, {
        productName: p.productName,
        variant: p.variant,
        productPrice: p.productPrice,
        quantity: p.quantity,
        // Reset hasil step 2 (kurir/ongkir/bayar) karena keranjang/identitas berubah.
        shippingCost: 0, shippingOriginalCost: 0, shippingSubsidy: 0, codFee: 0,
        shippingMethod: '', courier: '', logistic_code: '', rate_code: '',
        sourceForm: 'wizard_step1',
    });
    // Identitas (nama/WA/alamat teks) bukan whitelist update_wizard_order →
    // RPC khusus fase draft (trigger amankan alamat asli pertama).
    // JANGAN timpa nama valid dengan "-" (insiden #32696/#32588: repatch dgn
    // state nama kosong → buildCustomerFields default "-" → nama asli hilang).
    // RPC preserve bila null/kosong/"-", tapi kirim null eksplisit lebih aman.
    const nm = String(p.customer || '').trim();
    const letters = nm.replace(/[^A-Za-zÀ-ÿ]/g, '');
    const safeCustomer = (!nm || nm === '-' || letters.length < 2) ? null : p.customer;
    await patchWizardStep1Identity(orderId, {
        customer: safeCustomer as any, customerPhone: p.customerPhone,
        shippingAddress: p.shippingAddress,
    });
    // Order sesi dipakai lagi → tetap bukan abandon (anti cart hantu).
    try { (hook as any).hasSubmittedRef.current = true; } catch { /* abaikan */ }
    try {
        sessionStorage.setItem(`wizardOrder_${form?.id}`, JSON.stringify({
            orderId, csId: built.assignedCsId || null,
            sig: buildStep1Sig(hook),
        }));
    } catch { /* sesi storage diblokir -> tetap jalan */ }
}
